import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'yesno',
    standalone: false
})
export class YesNoPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(value: boolean): string {
    return value ? this.translateService.instant('COMMON.LABELS.YES') : this.translateService.instant('COMMON.LABELS.NO');
  }
}
